module.exports = __webpack_public_path__ + "static/media/Logo-StartPlanning.363e0d4c.png";